import React from "react";

const ExperienceItem = ({ company, role, period, italic = false }) => (
  <div className="mb-6">
    <h3 className="text-lg font-bold">
      <strong className="purple">{company}</strong>
    </h3>
    <p className={`text-md ${italic ? 'italic' : 'font-semibold'} text-gray-700 mb-1`}>
      {role}
    </p>
    <p className="text-sm text-gray-600">{period}</p>
  </div>
);

const Experience = () => {
  const experiences = [
{
      company: "AMD",
      role: "Silicon Architecture Engineer",
      period: "May 2025 - Present"
    },
    {
      company: "ARPA-H (EIC Lab, Georgia Tech)",
      role: "Graduate Researcher, SoC Architecture",
      period: "September 2025 - April 2026"
    },
    {
      company: "Twistient (Contract)",
      role: "ASIC Design Engineer",
      period: "April 2025 - August 2025"
    },
    {
      company: "Google",
      role: "Hardware Engineering Intern",
      period: "May 2024 - August 2024"
    },
    {
      company: "Stebner Labs",
      role: "Research Engineer",
      period: "August 2021 - May 2024"
    },
    {
      company: "SpaceX",
      role: "Test Engineering Intern",
      period: "May 2023 - August 2023",
      italic: true
    }
  ];

  return (
    <div className="w-full p-6">
      <h1 className="project-heading">
        <strong>Experience</strong>
      </h1>
      <div>
        {experiences.map((exp, index) => (
          <ExperienceItem
            key={index}
            company={exp.company}
            role={exp.role}
            period={exp.period}
            italic={exp.italic}
          />
        ))}
      </div>
    </div>
  );
};

export default Experience;